<div #dropdownMenu class="dropdown-menu w-100" [ngClass]="{'d-none': values.length === 0}" [style.max-height.px]="320"
  tabindex="-1" (mousedown)="$event.preventDefault()">
  <ng-template #rt let-result="result" let-term="term" let-formatter="formatter">
    <app-highlight [result]="formatter(result)" [term]="term" class="d-block text-wrap"></app-highlight>
  </ng-template>
  @for (value of values; track value; let idx = $index) {
    <li
      [id]="'typeahead-record-'+idx"
      role="option"
      class="dropdown-item d-flex align-items-center text-truncate"
      style="cursor: pointer"
      (click)="onSelect(idx)"
      [attr.value]="idx"
      [class.pe-0]="showDelete"
      [attr.is-focus]="activeIndex === idx"
      [ngClass]="value ? value['cssClass'] || '' : ''">
      <ng-template [ngTemplateOutlet]="data.resultTemplate || rt"
                   [ngTemplateOutletContext]="{
                   result: value,
                   term: data.term,
                   formatter: data.resultFormatter
                   }">
      </ng-template>
      @if (showDelete) {
        <button
          class="input-group-text border-0 bg-transparent ms-auto"
          (click)="onDelete(idx); $event.stopPropagation()">
          <span class="fa fa-trash text-danger"></span>
        </button>
      }
    </li>
  }
</div>
